export enum RolesEnum {
  ADMIN = 'admin',
  CLINIC_GROUP_ADMIN = 'clinic_group_admin',
  CLINIC_ADMIN = 'clinic_admin',
  CLINIC_OPERATOR = 'clinic_operator',
  ENTERPRISE = 'enterprise',
  CUSTOMER = 'customer',
}
